import {RouteRecordRaw} from "vue-router";
import ExtensionStoreView from "@/extension/views/ExtensionStoreView.vue";
import ExtensionDetailsView from "@/extension/views/ExtensionDetailsView.vue";
import SponsorExtensions from "@/extension/views/SponsorExtensions.vue";
import ExtensionsProfitabilityView from "@/extension/views/ExtensionsProfitabilityView.vue";

/**
 * Query key in order to display the extension modal details.
 */
export const EXTENSION_DETAILS_QUERY_KEY = 'currentExtensionId';

const routes: RouteRecordRaw[] = [
    {
        path: '/extension-store',
        name: 'extension-store',
        component: ExtensionStoreView,
        meta: {
            title: 'Modules'
        }
    },
    {
        /*
         * The page of one module: its description and, when it declares one,
         * the component that sets it up. Any kind of module can have one — the
         * modal next door only advertises them.
         */
        path: '/extension/:extensionId',
        name: 'extension.detail',
        component: ExtensionDetailsView,
        props: true,
        meta: {
            title: 'Module'
        }
    },
    {
        path: '/extensions/profitability',
        name: 'extensions-profitability',
        component: ExtensionsProfitabilityView
    },
    {
        path: '/sponsorships/:sponsorId/extensions',
        name: 'sponsorship-extensions',
        component: SponsorExtensions,
    }
];

export default routes;
